<template>
  <div id="heroCarousel" class="carousel slide" data-bs-ride="carousel">
    <div id="inicio" class="carousel-inner">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="carousel-item"
        :class="{ 'active': index === activeIndex }"
        :data-bs-interval="slide.interval || 3000"
      >
        <img
          :src="'/image/' + slide.image"
          class="d-block w-100"
          :alt="slide.title"
        >
        <div class="carousel-caption d-none d-md-block">
          <h3>{{ slide.title }}</h3>
          <p>{{ slide.subtitle }}</p>
          <button
            class="custom-btn"
            :class="index % 2 === 0 ? 'btn-blue' : 'btn-yellow'"
            @click="irAFormulario"
          >
            {{ slide.buttonText }}
          </button>
        </div>
      </div>
    </div>

    <button class="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon"></span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon"></span>
    </button>

    <div class="carousel-indicators">
      <button
        v-for="(slide, index) in slides"
        :key="'ind-' + index"
        type="button"
        data-bs-target="#heroCarousel"
        :data-bs-slide-to="index"
        :class="{ active: index === activeIndex }"
      >
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroCarousel',
  data() {
    return {
      activeIndex: 0,
      carouselInstance: null,
      slides: [
        {
          title: "GM RISK PROFESIONALES EN SEGUROS",
          subtitle: "POR UNA CULTURA DEL SEGURO",
          image: "slide5.jpg",
          buttonText: "AGRADECEMOS TU CONFIANZA CON NOSOTROS"
        },
        {
          title: "PROTEGE LO QUE MÁS AMAS CON SOLUCIONES DISEÑADAS PARA TI",
          subtitle: "ASEGURAR TU HOGAR Y TU VIDA NO ES UN TRÁMITE. CON GMRISK LO LOGRAMOS JUNTOS",
          image: "slide1.jpg",
          buttonText: "CONTÁCTANOS"
        },
        {
          title: "SENTIRTE LIBRE TAMBIÉN ES SABER QUE ESTÁS PROTEGIDA",
          subtitle: "TE AYUDAMOS A TOMAR DECISIONES CONSCIENTES, REALES Y HECHAS A TU MEDIDA",
          image: "slide2.jpg",
          buttonText: "DESCUBRE CÓMO HACERLO POSIBLE"
        },
        {
          title: "CONSTRUYE UN PATRIMONIO ASEGURANDO TU VIDA",
          subtitle: "DESCUBRE CÓMO UNA DECISIÓN PUEDE TRANSFORMAR EL FUTURO DE TU FAMILIA",
          image: "slide3.jpg",
          buttonText: "CONOCE MÁS AQUÍ"
        },
        {
          title: "NO ESTÁS SOLO AL CUIDAR DE QUIENE AMAS",
          subtitle: "BRINDAMOS ORIENTACIÓN TRANSPARENTE PARA QUE TOMES DECISIONES CON CONFIANZA Y CALMA",
          image: "slide4.jpg",
          buttonText: "AGENDA TU CITA CON UN ASESOR"
        }
      ]
    };
  },
  mounted() {
    this.initCarousel();
  },
  methods: {
    initCarousel() {
      if (typeof bootstrap !== 'undefined') {
        this.carouselInstance = new bootstrap.Carousel(
          document.getElementById('heroCarousel'),
          { interval: 3000 }
        );
        document.getElementById('heroCarousel').addEventListener(
          'slid.bs.carousel',
          (event) => {
            this.activeIndex = event.to;
          }
        );
      }
    },
    irAFormulario() {
      this.$router.push("/formulario_contacto");
    }
  }
};
</script>

<style scoped>
body, html {
  margin: 0;
  padding: 0;
  font-family: 'Open Sans', sans-serif;
}

.carousel-item img {
  width: 100%;
  height: 90vh;
  object-fit: cover;
  filter: brightness(0.6);
}

.carousel-caption {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  text-shadow: 1px 1px 5px #000;
}

.carousel-indicators button {
  background-color: #fff;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: none;
  margin: 0 4px;
}

.carousel-indicators .active {
  background-color: #007bff;
}

/* Botón personalizado sin hover ni animación */
.custom-btn {
  border: none;
  padding: 10px 25px;
  font-size: 16px;
  font-weight: normal;
  border-radius: 20px;
  cursor: pointer;
  transition: none; /* sin animación */
}

/* Colores sin hover ni animación */
.btn-blue {
  background-color: #233d72;
  color: white;
}

.btn-yellow {
  background-color: #f5ac0f;
  color: white;
}

.carousel-caption h3 {
  font-size: 2.5rem;
  font-weight: normal;
  line-height: 1.2em;
  margin-bottom: 1rem;
  white-space: normal;
  word-break: break-word;
}

.carousel-caption p {
  margin-top: 1rem;
  font-size: 1.2rem;
  font-weight: normal;
}

/* ------------------- Parche responsive ------------------- */

/* Tablets y laptops pequeñas */
@media (max-width: 992px) {
  .carousel-item img {
    height: 70vh;
    min-height: 520px;
  }

  .carousel-caption {
    display: block;
    width: 78%;
    padding: 0;
  }

  .carousel-caption h3 {
    font-size: 1.8rem;
    line-height: 1.25;
    margin-bottom: 0.8rem;

    word-break: normal;
    overflow-wrap: normal;
  }

  .carousel-caption p {
    font-size: 1rem;
    line-height: 1.5;
    margin-top: 0.8rem;
    margin-bottom: 1rem;

    word-break: normal;
    overflow-wrap: normal;
  }

  .custom-btn {
    max-width: 100%;
    padding: 8px 20px;
    font-size: 14px;
    line-height: 1.3;
    white-space: normal;
  }
}

/* Tablets verticales y celulares */
@media (max-width: 768px) {
  .carousel-item img {
    height: 65vh;
    min-height: 500px;
  }

  .carousel-caption {
    display: block !important;
    width: 82%;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    padding: 0;
    transform: translate(-50%, -50%);
  }

  .carousel-caption h3 {
    font-size: 1.4rem;
    line-height: 1.25;
    margin-bottom: 0.6rem;
  }

  .carousel-caption p {
    font-size: 0.92rem;
    line-height: 1.45;
    margin: 0.6rem 0 1rem;
  }

  .custom-btn {
    padding: 8px 18px;
    font-size: 13px;
  }

  .carousel-control-prev,
  .carousel-control-next {
    width: 10%;
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    width: 22px;
    height: 22px;
  }

  .carousel-indicators {
    margin-bottom: 14px;
  }
}

/* Celulares pequeños */
@media (max-width: 576px) {
  .carousel-item img {
    height: 65vh;
    min-height: 480px;
  }

  .carousel-caption {
    width: 84%;
    top: 50%;
  }

  .carousel-caption h3 {
    font-size: 1.15rem;
    line-height: 1.25;
    margin-bottom: 0.5rem;
  }

  .carousel-caption p {
    font-size: 0.8rem;
    line-height: 1.4;
    margin: 0.5rem 0 0.9rem;
  }

  .custom-btn {
    max-width: 270px;
    padding: 7px 15px;
    font-size: 11px;
    border-radius: 20px;
  }

  .carousel-control-prev,
  .carousel-control-next {
    width: 11%;
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    width: 18px;
    height: 18px;
  }

  .carousel-indicators button {
    width: 8px;
    height: 8px;
    margin: 0 3px;
  }
}

/* Celulares muy pequeños */
@media (max-width: 380px) {
  .carousel-caption {
    width: 80%;
  }

  .carousel-caption h3 {
    font-size: 1rem;
  }

  .carousel-caption p {
    font-size: 0.74rem;
  }

  .custom-btn {
    max-width: 240px;
    padding: 7px 12px;
    font-size: 10px;
  }
}
</style>

